import selectColorTypeApp from "@/components/common/selectColorApp";
import { SITE_DOMAIN } from "@/constant";
import { AppInitialDataType } from "./app.type";

export const INITIAL_APP_SOCIAL_TYPE_INITIAL_DATA = [
  {
    icon: "/social-items/app-store.svg",
    text: "Apple Store",
    type: "app_store",
    active: false,
  },
  {
    icon: "/social-items/google-play.svg",
    text: "Google Play",
    type: "google_play",
    active: false,
  },
  {
    icon: "/social-items/amazon.svg",
    text: "Amazon",
    type: "amazon",
    active: false,
  },
];

export const addButton = [
  {
    value: "Learn more",
    icon: "",
  },
  {
    value: "View more apps",
    icon: "",
  },
  {
    value: "Watch the video",
    icon: "",
  },
  {
    value: "Custom",
    icon: "/common/edit-icon.svg",
  },
];
export const AppInitialData: AppInitialDataType = {
  payload: {
    name: "",
    design_colors_primary: selectColorTypeApp[0].color,
    design_colors_button: selectColorTypeApp[0].color,
    title: "",
    description: "",
    website: "",
    app_name: "",
    developer: "",
    button: "",
    button_url: "",
    app_store: "",
    google_play: "",
    showButton: false,
    socialItems: [
      {
        id: 0,
        icon: "/social-items/app-store.svg",
        url: "",
        type: "app_store",
        active: false,
      },
      {
        id: 1,
        icon: "/social-items/google-play.svg",
        url: "",
        type: "google_play",
        active: false,
      },
    ],
  },
  socialTypes: INITIAL_APP_SOCIAL_TYPE_INITIAL_DATA,
  addButton: addButton,
};
